import { render, staticRenderFns } from "./menu-tree.vue?vue&type=template&id=72a3975c&scoped=true&"
import script from "./menu-tree.vue?vue&type=script&lang=js&"
export * from "./menu-tree.vue?vue&type=script&lang=js&"
import style0 from "./menu-tree.vue?vue&type=style&index=0&id=72a3975c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3975c",
  null
  
)

export default component.exports